import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import trans from 'counterpart';
import moment from 'moment';
import DatePicker from './DatePicker';
import { getArrival, getDeparture } from '../../../preferences/selectors';
import { getFilter } from '../../../../selectors/filterSelectors';
import { setPreference } from '../../../../actions/preferenceActions';
import { INTERNAL_DATE } from '../../../../constants/dates';

class DepartureDatePicker extends Component {
  state = {
    dropdown: false,
    monthBlocked: false,
  }

  componentDidMount = () => {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount = () => {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  // This component is used as a ref, to use this function outside of this component
  open = () => this.setState({ dropdown: true })

  // This component is used as a ref, to use this function outside of this component
  close = () => this.setState({ dropdown: false })

  toggle = () => this.setState(prevState => ({ dropdown: !prevState.dropdown }))

  handleClickOutside = (event) => {
    if (this.picker && this.state.dropdown && !this.picker.contains(event.target)) {
      this.close();
    }
  }

  getFutureReservationsRoute = () => {
    if (process.env.RAZZLE_APP === 'dierenbos') {
      return trans('routes.reserve_dierenbos');
    }

    return trans('routes.reserve');
  }

  render = () => {
    const { date, onChange, setDepartureDate, toggle } = this.props;
    return (
      <div className={`departure-date form-dropdown dropdown ${this.state.dropdown && !this.props.loading ? 'show' : ''}`} ref={(ref) => { this.picker = ref; }}>
        <div className="dropdown-toggle" onClick={this.toggle}>
          <div className="dropdown-filter">
            <div className="dropdown-heading">{trans('label.departure_date')}</div>
            <div className="dropdown-value">
              {date ? moment(date).format('DD-MM-YYYY') : trans('label.select_date')}
            </div>
          </div>
        </div>
        {this.state.dropdown && (
          <div className={`dropdown-menu${this.state.monthBlocked ? ' future-date' : ''}`}>
            <div className={this.props.loading ? 'loading-dropdown loading-active' : ''}>
              {this.props.loading && (
                <DatePicker
                  start={moment().format(INTERNAL_DATE)}
                  end={this.props.date}
                  date={moment()}
                />
              )}
              {!this.props.loading && (
                <DatePicker
                  start={this.props.arrival || moment().format(INTERNAL_DATE)}
                  end={this.props.date}
                  date={this.props.date}
                  focus={this.props.arrival || moment().format(INTERNAL_DATE)}
                  availableDates={this.props.availableDates}
                  onDateClick={(date) => {
                    setDepartureDate(date);
                    if (toggle) toggle('openFilters', true);
                    onChange(date);
                    this.setState({
                      dropdown: false
                    });
                  }}
                  onMonthChange={(date) => {
                    if (date > moment('2020-12-31')) {
                      return this.setState({ monthBlocked: true });
                    }

                    return this.setState({ monthBlocked: false });
                  }}
                />
              )}
            </div>
            <div className="future-booking">
              <div>
                <p>{trans('label.future_booking')}</p>
                <p>{trans('label.future_booking_two')}</p>
                <a className="btn btn-mail" href={this.getFutureReservationsRoute()}>{trans('label.book')}</a>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

DepartureDatePicker.defaultProps = {
  onChange: () => {}
};

DepartureDatePicker.propTypes = {
  arrival: PropTypes.string,
  availableDates: PropTypes.array,
  date: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  loading: PropTypes.bool,
  setDepartureDate: PropTypes.func.isRequired,
  toggle: PropTypes.func,
  onChange: PropTypes.func
};

const mapStateToProps = state => ({
  arrival: getArrival(state),
  availableDates: getFilter('departures')(state),
  loading: state.booking.isLoading,
  date: getDeparture(state)
});

const mapDispatchToProps = dispatch => ({
  setDepartureDate: date => dispatch(setPreference('departure', date.format(INTERNAL_DATE)))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  // We need to pass the forwardRef param to make sure we can use a ref on the actual component
  // See https://react-redux.js.org/api/connect#forwardref-boolean
  { forwardRef: true }
)(DepartureDatePicker);
